export default {
    isSoftwareCartEmpty: false,
    isHardwareCartEmpty: false,
    hasMultilineShipping: false,
    cablesInCartCount: null,
    productsInCart: [],
    productCostsInfo: null,
    hardwareCart: {},
    softwareCart: {},
    renewalDiscountMatrix: {}
}
